'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M80 204.8L80 496l128 0 0-184 0-8 8 0 144 0 8 0 0 8 0 184 128 0 0-291.2L288 26.5 80 204.8zM400 48l0 53.5 96 82.3L496 48l-96 0z', 'M293.2 9.9L288 5.5l-5.2 4.5-280 240 10.4 12.1L64 218.5 64 504l0 8 8 0 432 0 8 0 0-8 0-285.5 50.8 43.5 10.4-12.1L512 197.5 512 40l0-8-8 0L392 32l-8 0 0 8 0 47.7L293.2 9.9zM400 101.5L400 48l96 0 0 135.7-96-82.3zm96 103.4L496 496l-128 0 0-184 0-8-8 0-144 0-8 0 0 8 0 184L80 496l0-291.2L288 26.5 496 204.8zM352 496l-128 0 0-176 128 0 0 176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;